<avn-dialog-layout>
  <avn-dialog-header [title]="'deviceFields.DEVICE.DOWNLOAD_LOGS.TITLE_50' | transloco"></avn-dialog-header>

  <avn-dialog-content avnScroll>
    <avn-data-table
      [columns]="columns"
      [dataSource]="dataSource$ | async"
      [rowHeight]="80"
      [tableHeight]="'auto'"
      [showHeader]="true"
      [serverSorting]="false"
      [infiniteScrollEnabled]="false"
    >
      <ng-template #statusTemplate let-row="row">
        <div class="status" *ngIf="row.status">
          <avn-icon
            [fontSize]="18"
            [icon]="DownloadLogsTaskIcons[row.status]"
            [avnTheme]="DownloadLogsTaskThemes[row.status]">
          </avn-icon>
          <span>{{ 'deviceFields.DEVICE.DOWNLOAD_LOGS.SUMMARY_MODAL.STATUS.' + row.status + '_20' | transloco }}</span>
        </div>
      </ng-template>

      <ng-template #actionsTemplate let-row="row">
        <avn-data-table-actions [dataRow]="row">
          <avn-icon
            *ngIf="row.status === 'SUCCESS'"
            [icon]="'content:download'"
            (click)="download(row)"
          ></avn-icon>
        </avn-data-table-actions>
      </ng-template>

      <ng-template #messageTemplate let-row="row">
        <div class="message" *ngIf="row.status === 'FAIL'">
          <span>{{ row.errMsg }}</span>
        </div>
      </ng-template>

    </avn-data-table>
  </avn-dialog-content>
</avn-dialog-layout>
